namespace TabAurous.OMS {
    export interface VoucherTaxDetailsRow {
        DetailsId?: number;
        VoucherTypeId?: number;
        TaxId?: number;
        TaxName?: string;
        TaxType?: string;
        TaxRate?: number;
        GroupId?: number;
        IsInterState?: boolean;
    }

    export namespace VoucherTaxDetailsRow {
        export const idProperty = 'DetailsId';
        export const localTextPrefix = 'OMS.VoucherTaxDetails';
        export const lookupKey = 'OMS.VoucherTaxDetails';

        export function getLookup(): Q.Lookup<VoucherTaxDetailsRow> {
            return Q.getLookup<VoucherTaxDetailsRow>('OMS.VoucherTaxDetails');
        }
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = '*';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            DetailsId = "DetailsId",
            VoucherTypeId = "VoucherTypeId",
            TaxId = "TaxId",
            TaxName = "TaxName",
            TaxType = "TaxType",
            TaxRate = "TaxRate",
            GroupId = "GroupId",
            IsInterState = "IsInterState"
        }
    }
}
